import PropTypes from 'prop-types';
import React from 'react';

import {useInteractionStore} from '../../../store/slices/interactionStore';
import MessageText from '../MessageText';
import './MessageBankList.style.scss';

const MessageBankList = (props) => {
  const haveOnlyPsrMigratedSelected = useInteractionStore(
    (state) => state.haveOnlyPsrMigratedSelected
  );

  return (
    <>
      {!haveOnlyPsrMigratedSelected && (
        <>
          <MessageText
            id={props.message.id}
            text={props.message.text}
            html-id="message-info-bank"
            data-testid="message-info-bank"
            data-aut-test="message-info-bank"
          />
          <div className="message-line" data-testid="message-received">
            <div
              className="message-receive"
              id="msg-info-bank-list"
              data-aut-test="message-receive-info-list-bank"
              data-testid="message-receive-info-list-bank"
            >
              <div className="message-div">
                <ul className="style-list">
                  <li>1 - Banco do Brasil S.A.</li>
                  <li>33 - Banco Santander (Brasil) S.A.</li>
                  <li>41 - Banco do Estado do Rio Grande do Sul S.A.</li>
                  <li>104 - Caixa Econômica Federal</li>
                  <li>212 - Banco Original</li>
                  <li>237 - Banco Bradesco S.A.</li>
                  <li>341 - Itaú Unibanco S.A.</li>
                  <li>634 - Banco Triângulo S.A.</li>
                  <li>756 - Banco Cooperativo do Brasil S.A. - BANCOOB</li>
                  <li>748 - Banco Cooperativo Sicred S.A.</li>
                </ul>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

MessageBankList.propTypes = {
  message: PropTypes.object
};

export default MessageBankList;
